import styled, { keyframes } from 'styled-components'

const appearFromRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
`

export const Container = styled.div`
  .banners {
    margin: 1rem 1rem 1rem 0;
    width: 120px;
    max-width: 120px;
    max-height: 80px;
  }
  form {
    .label-journey {
      display: block;
      width: 100%;
      min-height: 16px;
      font-size: 14px;
      color: rgb(135, 134, 139);
      margin-bottom: 8px;
    }
    .padding-top {
      padding-top: 1rem;
    }
  }
`

export const Content = styled.div`
  width: 100%;
  text-align: center;
  animation: ${appearFromRight} 0.5s ease;

  h5 {
    font-size: 1.5rem;
    color: var(--color-gray);

    strong {
      color: var(--color-green-light);
    }
  }

  p {
    padding: 1rem;
  }
`
